import Vue from 'vue';
import Router from 'vue-router';
import routesConstant from '../constants/routes';
const CropImage = () => import('../components/CropImage');
const Login = () => import('../components/Login');
const File = () => import('../components/File');
const Iframe = () => import('../components/Iframe');
const MainLayout = () => import('../components/MainLayout');

const ModbusMaster = () => import('../components/Modbus/ModbusMaster');
const MbNetworks = () => import('../components/Modbus/MbNetworks');
const MbDevices = () => import('../components/Modbus/MbDevices');
const MbPoints = () => import('../components/Modbus/MbPoints');
const MbAllPointView = () => import('../components/Modbus/MbAllPointView');
const MbAllDeviceView = () => import('../components/Modbus/MbAllDeviceView');
const MbAllPointViewOfAllNetworks = () => import('../components/Modbus/MbAllPointViewOfAllNetworks');
const SlaveBiosAppsPage = () => import('../components/SlaveBiosApps/slaveBiosAppsPage.vue');
const UpdateService = () => import('../components/UpdateService');
const Scanning = () => import('../components/Scanning/Scanning');
const SettingPage = () => import('../components/Setting/SettingPage.vue');
const Services = () => import('../components/Services/Services');
const BacNetServer = () => import('../components/Bacnet/BacNetServer');
const Exception403 = () => import('../components/Exception403');
const RubixApps = () => import('../components/RubixApps/RubixApps');
const SchedulePage = () => import('../components/Schedule/SchdulePage.vue');
const MasterSlaves = () => import('../components/MasterSlaves/MasterSlaves.vue');
const Logging = () => import('../components/Logging');
const ApiClient = () => import('../components/ApiClient/ApiClient');
const AppManager = () => import('../components/AppManager');
const ServiceMapping = () => import('../components/ServiceMapping/ServiceMapping.vue');
const IO10Config = () => import('../components/io-config/io-10-config.vue');
const UserManagement = () => import('../components/UserManagement/userManagementPage.vue');

const LoraNetwork = () => import('../components/Lora/LoraNetwork');
const LnDevices = () => import('../components/Lora/LnDevices');
const LnPoints = () => import('../components/Lora/LnPoints');
const LnAllPointView = () => import('../components/Lora/LnAllPointView');

const RubixDriver = () => import('../components/RubixDriver/RubixDriver');
const RdNetworks = () => import('../components/RubixDriver/RdNetworks');
const RdDevices = () => import('../components/RubixDriver/RdDevices');
const RdPoints = () => import('../components/RubixDriver/RdPoints');
const RdAllPointView = () => import('../components/RubixDriver/RdAllPointView');
const RdAllDeviceView = () => import('../components/RubixDriver/RdAllDeviceView');
const RdAllPointViewOfAllNetworks = () => import('../components/RubixDriver/RdAllPointViewOfAllNetworks');

const MqttPage = () => import('../components/Mqtt/MqttPage');

const BacnetMaster = () => import('../components/BacnetMaster/BacnetMaster');
const BmNetworks = () => import('../components/BacnetMaster/BmNetworks');
const BmDevices = () => import('../components/BacnetMaster/BmDevices');
const BmPoints = () => import('../components/BacnetMaster/BmPoints');
const BmAllPointView = () => import('../components/BacnetMaster/BmAllPointView');
const BmAllDeviceView = () => import('../components/BacnetMaster/BmAllDeviceView');
const BmAllPointViewOfAllNetworks = () => import('../components/BacnetMaster/BmAllPointViewOfAllNetworks');

const RFStreams = () => import('../components/RubixFlow/Streams/streams.vue');
const RFWriters = () => import('../components/RubixFlow/Writers/writers.vue');
const RFConsumers = () => import('../components/RubixFlow/Consumers/consumers.vue');
const RFProducers = () => import('../components/RubixFlow/Producers/producers.vue');
const RFStreamsPage = () => import('../components/RubixFlow/Streams/streamsPage.vue');
const RFFlowNetwork = () => import('../components/RubixFlow/FlowNetwork/flowNetwork.vue');
const RFCommandGroup = () => import('../components/RubixFlow/CommandGroup/commandGroup.vue');
const RFWriterClones = () => import('../components/RubixFlow/WriterClones/writerClones.vue');

const RFNetworks = () => import('../components/RubixFlow/RfNetworks/rfNetworks.vue');
const RFDevices = () => import('../components/RubixFlow/RfDevices/rfDevices.vue');
const RFPoints = () => import('../components/RubixFlow/RfPoints/rfPoints.vue');
const RFNetworkPage = () => import('../components/RubixFlow/RfNetworks/rfNetworkPage.vue');
const RFFlowNetworkPage = () => import('../components/RubixFlow/FlowNetwork/flowNetworkPage.vue');
const RFFlowNetworkStreams = () => import('../components/RubixFlow/FlowNetworkStreams/flowNetworkStreams.vue');
const RFAllNetworkDevices = () => import('../components/RubixFlow/RfAllNetworkDevices/rfAllNetworkDevices.vue');
const RFAllPoints = () => import('../components/RubixFlow/RfAllPoints/rfAllPoints.vue');
const PluginsPage = () => import('../components/Plugins/PluginsPage.vue');
const RFSchedules = () => import('../components/RubixFlow/Schedules/rfSchedules.vue');
const RFFlowNetworkClonePage = () => import('../components/RubixFlow/FlowNetworkClone/flowNetworkClonePage.vue');
const RFFlowNetworkClone = () => import('../components/RubixFlow/FlowNetworkClone/flowNetworkClone.vue');
const RFFlowNetworkStreamsClone = () =>
  import('../components/RubixFlow/FlowNetworkStreamsClone/flowNetworkStreamsClone.vue');

const RFFlowframeworkUpgrade = () => import('../components/RubixFlow/RFFrameworkUpgrade/rfFrameworkUpgrade.vue');
const SyncLogs = () => import('../components/SyncLogs/syncLogs.vue');
const ErrorLogsPage = () => import('../components/ErrorLogs/ErrorLogsPage.vue');

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'login', component: Login, meta: { guest: true } },
    {
      path: '',
      name: '',
      component: MainLayout,
      meta: { auth: true },
      children: [
        { path: '', redirect: 'services' },
        { path: 'error-logs', component: ErrorLogsPage, meta: { settingKey: 'enableErrorLogs' } },
        { path: 'services', name: 'services', component: Services, meta: { settingKey: 'services' } },
        { path: 'file', name: 'file', component: File, meta: { settingKey: 'fileManager' } },
        { path: 'bacnet-server', name: 'bacnet-server', component: BacNetServer, meta: { settingKey: 'bacnetServer' } },
        {
          path: routesConstant.rfFlowNetworkRoot,
          name: '',
          component: RFFlowNetworkPage,
          meta: { settingKey: 'flowNetwork' },
          children: [
            { path: '', redirect: routesConstant.rfFlowNetwork },
            {
              path: routesConstant.rfFlowNetwork,
              name: 'rubix-flow-network',
              component: RFFlowNetwork,
              meta: { settingKey: 'flowNetwork' },
            },
            {
              path: routesConstant.rfFlowNetworkStreams,
              name: 'rubix-flow-network-streams',
              component: RFFlowNetworkStreams,
              meta: { settingKey: 'flowNetwork' },
            },
            {
              path: routesConstant.rfFlowNetworkProducer,
              name: 'rubix-flow-network-producer',
              component: RFProducers,
              meta: { settingKey: 'flowNetwork' },
            },
            {
              path: routesConstant.rfFlowNetworkWriterClone,
              name: 'rubix-flow-network-writer-clone',
              component: RFWriterClones,
              meta: { settingKey: 'flowNetwork' },
            },
          ],
        },
        {
          path: routesConstant.rfFlowNetworkCloneRoot,
          name: '',
          component: RFFlowNetworkClonePage,
          meta: { settingKey: 'flowNetworkClone' },
          children: [
            { path: '', redirect: routesConstant.rfFlowNetworkClone },
            {
              path: routesConstant.rfFlowNetworkClone,
              name: 'rubix-flow-network-clone',
              component: RFFlowNetworkClone,
              meta: { settingKey: 'flowNetworkClone' },
            },
            {
              path: routesConstant.rfFlowNetworkStreamsClone,
              name: 'rubix-flow-network-streams-clone',
              component: RFFlowNetworkStreamsClone,
              meta: { settingKey: 'flowNetworkClone' },
            },
            {
              path: routesConstant.rfFlowNetworkCloneConsumers,
              name: 'rubix-flow-network-clone-consumer',
              component: RFConsumers,
              meta: { settingKey: 'flowNetworkClone' },
            },
            {
              path: routesConstant.rfWriters,
              name: 'rubix-flow-network-writer',
              component: RFWriters,
              meta: { settingKey: 'flowNetworkClone' },
            },
          ],
        },
        {
          path: routesConstant.rfNetworkDevicePoint,
          name: '',
          component: RFNetworkPage,
          meta: { settingKey: 'flowNetworkNDP' },
          children: [
            { path: '', redirect: routesConstant.rfNetworks },
            {
              path: routesConstant.rfNetworks,
              name: 'rf-networks',
              component: RFNetworks,
              meta: { settingKey: 'flowNetworkNDP' },
            },
            {
              path: routesConstant.rfDevices,
              name: 'rf-devices',
              component: RFDevices,
              meta: { settingKey: 'flowNetworkNDP' },
            },
            {
              path: routesConstant.rfPoints,
              name: 'rf-points',
              component: RFPoints,
              meta: { settingKey: 'flowNetworkNDP' },
            },
          ],
        },

        {
          path: routesConstant.rfAllNetworkDevices,
          name: 'rubix-flow-all-network-devices',
          component: RFAllNetworkDevices,
          meta: { settingKey: 'rubixFlowAllNetworkDevices' },
        },
        {
          path: routesConstant.rfAllPoints,
          name: 'rubix-flow-all-points',
          component: RFAllPoints,
          meta: { settingKey: 'rubixFlowAllPoints' },
        },
        {
          path: routesConstant.rfSchedules,
          name: 'rubix-flow-schedules',
          component: RFSchedules,
          meta: { settingKey: 'rfSchedules' },
        },
        {
          path: 'modbus',
          name: '',
          component: ModbusMaster,
          children: [
            { path: '', redirect: 'networks' },
            { path: 'networks', name: 'modbus-networks', component: MbNetworks, meta: { settingKey: 'modbus' } },
            {
              path: 'networks/:id/devices',
              name: 'modbus-devices',
              component: MbDevices,
              meta: { settingKey: 'modbus' },
            },
            { path: 'devices/:id/points', name: 'modbus-points', component: MbPoints, meta: { settingKey: 'modbus' } },
            {
              path: 'networks/:id/points-view',
              name: 'modbus-all-point-view',
              component: MbAllPointView,
              meta: { settingKey: 'modbus' },
            },
            {
              path: 'networks/devices-view',
              name: 'modbus-all-device-view',
              component: MbAllDeviceView,
              meta: { settingKey: 'modbus' },
            },
            {
              path: 'networks/all-networks-points-view',
              name: 'modbus-all-networks-points-view',
              component: MbAllPointViewOfAllNetworks,
              meta: { settingKey: 'modbus' },
            },
          ],
        },
        { path: 'schedules', name: 'schedules', component: SchedulePage, meta: { settingKey: 'schedules' } },
        { path: 'api-client', name: 'apiClient', component: ApiClient, meta: { settingKey: 'apiClient' } },
        { path: 'ip-scanning', name: 'ipScanning', component: Scanning, meta: { settingKey: 'ipScanning' } },
        {
          path: 'rubix-driver',
          name: '',
          component: RubixDriver,
          children: [
            { path: '', redirect: 'networks' },
            {
              path: 'networks',
              name: 'rubix-driver-networks',
              component: RdNetworks,
              meta: { settingKey: 'cloudNetworks' },
            },
            {
              path: 'networks/:id/devices',
              name: 'rubix-driver-devices',
              component: RdDevices,
              meta: { settingKey: 'cloudNetworks' },
            },
            {
              path: 'devices/:id/points',
              name: 'rubix-driver-points',
              component: RdPoints,
              meta: { settingKey: 'cloudNetworks' },
            },
            {
              path: 'networks/:id/points-view',
              name: 'rubix-driver-all-point-view',
              component: RdAllPointView,
              meta: { settingKey: 'cloudNetworks' },
            },
            {
              path: 'networks/devices-view',
              name: 'rubix-driver-all-device-view',
              component: RdAllDeviceView,
              meta: { settingKey: 'cloudNetworks' },
            },
            {
              path: 'networks/all-networks-points-view',
              name: 'rubix-driver-all-networks-points-view',
              component: RdAllPointViewOfAllNetworks,
              meta: { settingKey: 'cloudNetworks' },
            },
          ],
        },
        { path: 'logging', name: 'logging', component: Logging, meta: { settingKey: 'logging' } },
        { path: 'iframe/:id', name: 'iframe', component: Iframe },
        { path: 'update-service/:id', name: 'update-service', component: UpdateService },
        { path: 'crop-image', name: 'Crop Image', component: CropImage },
        {
          path: 'service-mapping',
          name: 'Service Mapping',
          component: ServiceMapping,
          meta: { settingKey: 'serviceMapping' },
        },
        {
          path: 'sync-logs',
          name: 'Sync Logs',
          component: SyncLogs,
          meta: { settingKey: 'syncLogs' },
        },
        { path: 'mqtt', name: 'MQTT', component: MqttPage, meta: { settingKey: 'mqtt' } },
        { path: 'setting', name: 'Setting', component: SettingPage },
        { path: 'exception-403', name: 'exception-403', component: Exception403 },
        {
          path: 'lora-network',
          name: '',
          component: LoraNetwork,
          children: [
            { path: '', redirect: 'devices' },
            { path: 'devices', name: 'lora-device', component: LnDevices, meta: { settingKey: 'lora' } },
            { path: 'devices/:id/points', name: 'lora-points', component: LnPoints, meta: { settingKey: 'lora' } },
            {
              path: 'points-view',
              name: 'lora-all-point-view',
              component: LnAllPointView,
              meta: { settingKey: 'lora' },
            },
          ],
        },
        { path: 'app-manager', name: 'app-manager', component: AppManager },
        { path: 'rubix-apps', name: 'rubix-apps', component: RubixApps },
        { path: 'master-slaves', name: 'master-slaves', component: MasterSlaves },
        {
          path: 'slaves-bios-apps',
          name: 'slaves-bios-apps',
          component: SlaveBiosAppsPage,
        },
        { path: 'io-10-config', name: 'io-10-config', component: IO10Config },
        { path: 'user-management', name: 'user-mangement', component: UserManagement },
        {
          path: 'bacnet-master',
          name: '',
          component: BacnetMaster,
          children: [
            { path: '', redirect: 'networks' },
            { path: 'networks', name: 'bacnet-networks', component: BmNetworks, meta: { settingKey: 'bacnetMaster' } },
            {
              path: 'networks/:id/devices',
              name: 'bacnet-devices',
              component: BmDevices,
              meta: { settingKey: 'bacnetMaster' },
            },
            {
              path: 'devices/:id/points',
              name: 'bacnet-points',
              component: BmPoints,
              meta: { settingKey: 'bacnetMaster' },
            },
            {
              path: 'networks/:id/points-view',
              name: 'bacnet-all-point-view',
              component: BmAllPointView,
              meta: { settingKey: 'bacnetMaster' },
            },
            {
              path: 'networks/devices-view',
              name: 'bacnet-all-device-view',
              component: BmAllDeviceView,
              meta: { settingKey: 'bacnetMaster' },
            },
            {
              path: 'networks/all-networks-points-view',
              name: 'bacnet-all-networks-points-view',
              component: BmAllPointViewOfAllNetworks,
              meta: { settingKey: 'bacnetMaster' },
            },
          ],
        },
        { path: 'plugins', name: 'plugins', component: PluginsPage, meta: { settingKey: 'plugins' } },
        {
          path: routesConstant.rfFrameworkUpgrade,
          name: 'rubix-flow-framework-upgrade',
          component: RFFlowframeworkUpgrade,
        },
      ],
    },
  ],
});

export default router;
